import NavComponent from "../lib/nav_component";

export const PaneComponentConfig = {
    baseHtmlClass: 'nav__pane',
    selector: '.nav__pane',
};

export class PaneComponent extends NavComponent {

    constructor(id_or_element, pane, config) {
        super(id_or_element, config);
        this.pane = pane;
    }

    render() {
    };

    renderAttachedState(isAttached) {
        if (!!isAttached) { // If attached…
            this.removeHtmlClassState('detached');
        } else {
            this.addHtmlClassState('detached');
        }
    }
}